// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2zDnl","amount":"Amount_amount__3V0T-","tip":"Amount_tip__2fxsq","tipHeader":"Amount_tipHeader__tL9J5","tipsWrap":"Amount_tipsWrap__1mPbx"};